import { render, staticRenderFns } from "./LandingFeaturedCapitalCities.vue?vue&type=template&id=0f51fd33"
import script from "./LandingFeaturedCapitalCities.vue?vue&type=script&lang=ts"
export * from "./LandingFeaturedCapitalCities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports